import { render, staticRenderFns } from "./FileMinusIcon.vue?vue&type=template&id=0aacefc0&"
import script from "./FileMinusIcon.vue?vue&type=script&lang=js&"
export * from "./FileMinusIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports